import { Link } from '@tanstack/react-router';

import { SeaSnagLogo } from '../sea-snag-logo';

export function LandingFooter() {
  return (
    <footer className="border-t border-border py-16">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 px-6 md:grid-cols-[2fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2">
            <SeaSnagLogo className="size-7" />
            <span className="text-base font-semibold text-foreground">Sea Snag</span>
          </div>
          <p className="mt-3 max-w-sm text-sm text-muted-foreground">
            Charter pricing intelligence for operators who treat pricing as a discipline.
          </p>
        </div>

        <FooterColumn
          heading="Product"
          links={[
            { label: 'Competitor sets', href: '#competitor-sets' },
            { label: 'Alerts', href: '#alerts' },
            { label: 'Dynamic pricing', href: '#dynamic-pricing' },
            { label: 'How it works', href: '#how-it-works' },
            { label: 'Beta access', href: '#beta' },
          ]}
        />

        <FooterColumn
          heading="Company"
          links={[
            { label: 'Privacy', href: '/privacy', router: true },
            { label: 'Terms', href: '/terms', router: true },
            { label: 'Contact', href: 'mailto:hello@seasnag.com' },
          ]}
        />
      </div>

      <div className="mx-auto mt-12 max-w-6xl px-6">
        <p className="font-mono text-xs tabular-nums text-muted-foreground">© 2026 Sea Snag</p>
      </div>
    </footer>
  );
}

function FooterColumn({
  heading,
  links,
}: {
  heading: string;
  links: Array<{ label: string; href: string; router?: boolean }>;
}) {
  return (
    <div>
      <p className="mb-4 font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground">
        {heading}
      </p>
      <ul className="space-y-3">
        {links.map((link) => (
          <li key={link.href}>
            {link.router ? (
              <Link to={link.href} className="text-sm text-foreground/80 hover:text-foreground">
                {link.label}
              </Link>
            ) : (
              <a href={link.href} className="text-sm text-foreground/80 hover:text-foreground">
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
